<div *ngIf="sessionExpiredBannerVisible"
  class="w-full bg-[#fde68a] text-[#8a4d0f] px-4 py-2 flex items-center justify-between gap-3 text-sm font-medium border-b border-[#f59e0b]"
  role="alert">

  <span>

    Your session has expired. Re-login to continue - your in-progress

    work has been preserved.

  </span>

  <span class="flex items-center gap-2">

    <button type="button" class="text-xs px-3 py-1 rounded bg-[#92400e] text-white border-0 cursor-pointer"
      (click)="reloginFromBanner()">

      Re-login

    </button>

    <button type="button"
      class="text-xs px-2 py-1 rounded bg-transparent text-[#8a4d0f] underline border-0 cursor-pointer"
      (click)="dismissSessionBanner()">

      Dismiss

    </button>

  </span>

</div>

<header class="header" tuiNavigationHeader>

  <div class="ml-0 pl-0">

    <div class="h-[40px]">

      <img src="/assets/logo-horizontal.png" class="w-full h-full object-contain" alt="Royal Hospital Logo" />

    </div>

  </div>

  <hr />

  <div class="flex items-center gap-2">

    <ng-container *ngIf="isPrivilegedAdmin">

      <button tuiIconButton appearance="flat" type="button" size="m" class="cursor-pointer relative"
        title="Notifications" [tuiDropdown]="notificationContent" [(tuiDropdownOpen)]="notificationDropdownOpen"
        [tuiDropdownAlign]="align" (click)="toggleNotificationDropdown()">

        <tui-icon icon="@tui.bell"></tui-icon>

        <span *ngIf="unopenedNotificationCount > 0" style="

position: absolute;

top: -2px;

right: -2px;

display: flex;

align-items: center;

justify-content: center;

min-width: 18px;

height: 18px;


background-color: #dc2626; /* red-600 */

color: white;

font-size: 10px;

font-weight: bold;

border-radius: 50%;

border: 2px solid white; /* Adds separation from the bell icon */

z-index: 10;

" aria-label="Unread notifications">

          {{ unopenedNotificationCount > 99 ? "99+" : unopenedNotificationCount }}

        </span>

      </button>

      <ng-template #notificationContent>

        <div class="bg-white shadow-lg rounded-md border border-gray-200 w-[320px] max-h-[400px] flex flex-col">

          <div class="flex items-center justify-between px-3 py-2 border-b border-gray-100">

            <p class="text-sm font-semibold m-0 text-[#1E293B]">Notifications</p>

            <button *ngIf="unopenedNotificationCount > 0" type="button"
              class="text-xs text-[#6C066D] underline cursor-pointer bg-transparent border-0 p-0"
              (click)="markAllNotificationsRead()">

              Mark all read

            </button>

          </div>

          <div class="overflow-y-auto flex-1">

            <ng-container *ngIf="notifications.length > 0; else emptyState">

              <div *ngFor="let n of notifications"
                class="relative flex items-start group border-b border-gray-50 hover:bg-gray-50"
                [class.bg-blue-50]="!n.isOpened">

                <button type="button" class="flex-1 text-left px-3 py-2 cursor-pointer bg-transparent border-0"
                  (click)="openNotification(n)">

                  <p class="text-xs font-semibold text-[#1E293B] m-0 whitespace-normal break-words">

                    {{ n.title }}

                  </p>

                  <p class="text-[11px] text-[#6B6D80] m-0 mt-0.5 whitespace-normal break-words">

                    {{ n.description }}

                  </p>

                  <p class="text-[10px] text-[#9CA3AF] m-0 mt-0.5">

                    {{ n.createdAt | date: "short" }}

                  </p>

                </button>

                <button type="button"
                  class="opacity-0 group-hover:opacity-100 transition-opacity p-2 mr-1 text-[#6B6D80] hover:text-[#92400e] cursor-pointer bg-transparent border-0 self-start"
                  (click)="dismissNotification(n, $event)" title="Dismiss notification"
                  aria-label="Dismiss notification">

                  <span class="text-base leading-none">&times;</span>

                </button>

              </div>

            </ng-container>

            <ng-template #emptyState>

              <p class="text-xs text-center text-[#6B6D80] py-6 m-0">

                No notifications yet

              </p>

            </ng-template>

          </div>

        </div>

      </ng-template>

    </ng-container>

    <button tuiButton title="user-dropdown" type="button" class="cursor-pointer"
      [tuiAppearanceState]="open ? 'hover' : null" [tuiDropdown]="content" [(tuiDropdownOpen)]="open"
      [tuiDropdownAlign]="align">

      <div class="flex items-center space-x-3 mr-5">

        <div class="w-[30px] h-[30px] bg-red-600 rounded-full">
          <img class="object-cover w-full h-full rounded-full bg-white"
            [src]="loggedInUserImage || 'https://api.iconify.design/mdi/account.svg?color=%239ca3af'"
            alt="User Profile" />
        </div>

        <div class="flex flex-col items-start">

          <p class="text-[#6B6D80] text-xs font-semibold m-0 p-0">

            {{ loggedInUserName }}

          </p>

          <p class="text-[#474747] text-xs font-normal m-0 p-0">

            {{ loggedInUserRole }}

          </p>

        </div>

      </div>

    </button>

    <ng-template #content>

      <tui-data-list tuiDataListDropdownManager [size]="size">

        <button tuiOption type="button" class="my-custom-class" (click)="viewMyAccount(loggedInUserID)">

          My Account

        </button>

        <button tuiOption type="button" class="dropdown-hover" (click)="logout()">

          <span style="color: red">Logout</span>

        </button>

      </tui-data-list>

    </ng-template>

  </div>

</header>

<div [style.display]="'flex'">

  <aside style="height: calc(100vh - 48px);" [tuiNavigationAside]="expanded()" [class.sidebar-expanded]="expanded()"
    class="shrink-0 transition-all duration-200">

    <tui-aside-group *ngIf="loggedInUserRole !== 'HR'">

      <button automation-id="setting" iconStart="@tui.layout-dashboard" tuiAsideItem tuiChevron type="button">

        Dashboards

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/duty-roster']"
            [class._active]="router.url === '/admin/duty-roster'">

            Duty Roster

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/nurse-attendence']"
            [class._active]="

router.url === '/admin/nurse-attendence' ">

            Nurse Attendance

          </button>

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group *ngIf="loggedInUserRole !== 'HR'">

      <button automation-id="setting" iconStart="@tui.user-plus" tuiAsideItem tuiChevron type="button">

        <div class="text-custom">Users</div>

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/users/add-edit']"
            [class._active]="router.url === '/admin/users/add-edit'">

            Add User

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/users/']" [class._active]="

router.url === '/admin/users' || router.url === '/admin/users/'

">

            View Users

          </button>

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group *ngIf="loggedInUserRole !== 'HR'">

      <button automation-id="setting" iconStart="@tui.accessibility" tuiAsideItem tuiChevron type="button">

        Clients

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/client/add-edit']"
            [class._active]="router.url === '/admin/client/add-edit'">

            Add Client

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/client']" [class._active]="

router.url === '/admin/client' || router.url === '/admin/client/'

">

            View Clients

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/client/expired']"
            [class._active]="

router.url === '/admin/client/expired' || router.url === '/admin/client/expired/'

">

            Expired Clients

          </button>

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group>

      <button automation-id="setting" iconStart="@tui.stethoscope" tuiAsideItem tuiChevron type="button">

        Nurses

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/nurse/add-edit']"
            [class._active]="router.url === '/admin/nurse/add-edit'">

            Add Nurse

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/nurse']" [class._active]="

router.url === '/admin/nurse' || router.url === '/admin/nurse/'

">

            View Nurses

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/leave/add-edit']"
            [class._active]="router.url.startsWith('/admin/leave/add-edit')">

            Add New Leave

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/leave']"
            [class._active]="router.url === '/admin/leave' || router.url === '/admin/leave/'">

            View Leaves

          </button>

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group *ngIf="loggedInUserRole !== 'HR'">

      <button automation-id="setting" iconStart="@tui.ambulance" tuiAsideItem tuiChevron type="button">

        Extra Charges

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/procedures/add-edit']"
            [class._active]="router.url.startsWith('/admin/procedures/add-edit')">

            Add Extra Charges

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/procedures']" [class._active]="

router.url === '/admin/procedures' || router.url === '/admin/procedures/'

">

            View Extra Charges

          </button>

          <!--

Walk-in clients are stored as procedure records with a manually

entered name (no Client document). Both entries reuse the

unified Extra Charges screens via route data (walkIn: true).

-->

          <button class="sub-menu-item" tuiAsideItem type="button"
            [routerLink]="['/admin/walk-in-extra-charges/add-edit']"
            [class._active]="router.url.startsWith('/admin/walk-in-extra-charges/add-edit')">

            Add Walk-in Patient Charge

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/walk-in-extra-charges']"
            [class._active]="

router.url === '/admin/walk-in-extra-charges' || router.url === '/admin/walk-in-extra-charges/'

">

            View Walk-in Patient Charges

          </button>

          <!--

The legacy Manual Records "View" entry stays in the sidebar so

historical, non-registered manual entries are still inspectable

until they are migrated. New writes should go through the unified

Extra Charges form above (which posts to /procedure).

-->

          <!-- <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/manual-records']" [class._active]="

router.url === '/admin/manual-records' || router.url === '/admin/manual-records/'

">

            Legacy Manual Records (read-only)

          </button> -->

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group *ngIf="loggedInUserRole !== 'HR'">

      <button automation-id="setting" iconStart="@tui.hand-coins" tuiAsideItem tuiChevron type="button">

        Salary and Charges

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/salary-charge-config']"
            [class._active]="router.url === '/admin/salary-charge-config'">

            Salary and Charges Config

          </button>

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group *ngIf="loggedInUserRole !== 'HR'">

      <button automation-id="setting" iconStart="@tui.file-text" tuiAsideItem tuiChevron type="button">

        Reports

        <ng-template>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/reports/registered-clients']"
            [class._active]="router.url === '/admin/reports/registered-clients'">

            Registered Client Reports

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button"
            [routerLink]="['/admin/reports/non-registered-clients']"
            [class._active]="router.url === '/admin/reports/non-registered-clients'">

            Non Registered Client Reports

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/reports/inward-clients']"
            [class._active]="router.url === '/admin/reports/inward-clients'">

            Inward Client Reports

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/reports/walk-in-clients']"
            [class._active]="router.url === '/admin/reports/walk-in-clients'">

            Walk-in Client Reports

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/reports/income']"
            [class._active]="router.url === '/admin/reports/income'">

            Registration & Renewal Income

          </button>

          <button class="sub-menu-item" tuiAsideItem type="button" [routerLink]="['/admin/reports/consolidated-income']"
            [class._active]="router.url === '/admin/reports/consolidated-income'">

            Consolidated Income Report

          </button>

        </ng-template>

      </button>

    </tui-aside-group>

    <tui-aside-group *ngIf="canViewSessionLogs">

      <button automation-id="login-activity" iconStart="@tui.activity" tuiAsideItem type="button"
        [routerLink]="['/admin/login-activity']" [class._active]="router.url === '/admin/login-activity'">

        Login Activity

      </button>

    </tui-aside-group>

    <!-- <tui-aside-group>

<button automation-id="setting" iconStart="@tui.layers" tuiAsideItem tuiChevron type="button">

Invoices

<ng-template>

<button tuiAsideItem type="button" [routerLink]="['/admin/invoice/add-edit']" [class._active]="router.url === '/admin/invoice/add-edit'">

Add Invoice

</button>

<button tuiAsideItem type="button" [routerLink]="['/admin/invoice']" [class._active]="

router.url === '/admin/invoice' ||

router.url === '/admin/invoice/'

">

View Invoices

</button>

</ng-template>

</button>

</tui-aside-group> -->

    <hr />

    <footer>

      <button tuiAsideItem type="button" [iconStart]="expanded() ? '@tui.chevron-left' : '@tui.chevron-right'"
        (click)="handleToggle()">

        {{ expanded() ? "Collapse" : "Expand" }}

      </button>

    </footer>

  </aside>

  <div class="border-custom min-h-screen">

    <main tuiNavigationMain class="min-w-0 flex-1">

      <router-outlet />

    </main>

    <div class="min-w-0 flex-1 pt-60">

      <div class="bg-[#E5E7EA] h-[1px] w-full"></div>

      <div class="flex flex-row justify-between items-center px-4">

        <div>

          <p class="font-normal text-xs text-[#1E293B]">

            Royal Hospital | Version 1.5.0

          </p>

        </div>

        <div>

          <p class="font-normal text-xs text-[#1E293B]">

            Powered by

            <a href="https://www.purple.lk/?utm_source=Home Nursing Management System" target="_blank" rel="noopener"
              class="text-[#6C066D] no-underline">Purple Software

            </a>

          </p>

        </div>

      </div>

    </div>

  </div>

</div>

<!-- Expiring Clients Notification Modal -->

<div *ngIf="showExpiringClientsDialog"
  class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-[2px]"
  role="presentation">

  <!-- Overlay dismisses only after minimum view time -->

  <div class="absolute inset-0" aria-hidden="true" (click)="closeExpiringClientsDialog()"></div>

  <div role="dialog" aria-modal="true" aria-labelledby="expiring-clients-heading"
    class="relative w-full max-w-2xl max-h-[90vh] flex flex-col rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden">

    <div class="shrink-0 px-6 pt-6 pb-4 border-b border-slate-100 bg-white">

      <div class="flex gap-4 items-start">

        <div
          class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-700 ring-1 ring-amber-100"
          aria-hidden="true">

          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75">

            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />

          </svg>

        </div>

        <div class="min-w-0 pt-0.5">

          <h3 id="expiring-clients-heading" class="text-lg font-semibold text-slate-900 tracking-tight">

            Registration expiring soon

          </h3>

          <p class="mt-1 text-sm text-slate-500 leading-snug">

            The following registrations need renewal attention within seven days.

          </p>

        </div>

      </div>

    </div>

    <div class="min-h-0 flex-1 overflow-y-auto px-6 py-5 space-y-4">

      <div class="rounded-lg bg-slate-50 px-4 py-3 border border-slate-100">

        <p class="text-sm text-slate-700 m-0">

          <span class="font-semibold text-slate-900">{{ expiringClientsCount }}</span>

          {{ expiringClientsCount === 1 ? "client has" : "clients have" }} registration expiring in the next

          <span class="font-medium text-slate-900">7 days</span>.

        </p>

      </div>

      <div class="rounded-xl border border-slate-200 overflow-hidden bg-white">

        <div class="max-h-[min(18rem,40vh)] overflow-y-auto overscroll-contain">

          <table class="min-w-full text-left">

            <thead class="bg-slate-100/90 sticky top-0 z-[1] border-b border-slate-200 backdrop-blur-sm">

              <tr>

                <th class="px-4 py-2.5 text-xs font-semibold text-slate-600 uppercase tracking-wider">Client</th>

                <th class="px-4 py-2.5 text-xs font-semibold text-slate-600 uppercase tracking-wider">Ref no.</th>

                <th class="px-4 py-2.5 text-xs font-semibold text-slate-600 uppercase tracking-wider">Expires</th>

                <th class="px-4 py-2.5 text-xs font-semibold text-slate-600 uppercase tracking-wider text-right">Urgency

                </th>

              </tr>

            </thead>

            <tbody class="divide-y divide-slate-100">

              <tr *ngFor="let client of expiringClients" class="hover:bg-slate-50/80 transition-colors">

                <td class="px-4 py-3 text-sm font-medium text-slate-900 whitespace-nowrap">{{ client.guardianName ||
                  client.name || '—' }}</td>

                <td class="px-4 py-3 text-sm text-slate-600 font-mono tabular-nums whitespace-nowrap">

                  {{ formatExpiringClientId(client) }}

                </td>

                <td class="px-4 py-3 text-sm text-slate-600 whitespace-nowrap">{{ client.expiryDate | date : "MMM d, y"

                  }}</td>

                <td class="px-4 py-3 text-right whitespace-nowrap">

                  <span
                    class="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold ring-1 ring-inset tabular-nums"
                    [ngClass]="{

'bg-red-50 text-red-800 ring-red-200': getDaysRemaining(client.expiryDate) <= 2,

'bg-amber-50 text-amber-900 ring-amber-200':

getDaysRemaining(client.expiryDate) > 2 && getDaysRemaining(client.expiryDate) <= 5,

'bg-slate-100 text-slate-700 ring-slate-200': getDaysRemaining(client.expiryDate) > 5

}">

                    {{ getDaysRemaining(client.expiryDate) }} {{ getDaysRemaining(client.expiryDate) === 1 ? "day" :

                    "days" }}

                  </span>

                </td>

              </tr>

            </tbody>

          </table>

        </div>

      </div>

    </div>

    <div
      class="shrink-0 px-6 py-4 border-t border-slate-100 bg-slate-50/80 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">

      <div class="flex items-start gap-3 text-sm text-slate-600 min-w-0">

        <span class="mt-0.5 text-slate-400 shrink-0" aria-hidden="true">

          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">

            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />

          </svg>

        </span>

        <span class="leading-snug">

          You can dismiss this dialog at any time.

        </span>

      </div>

      <div class="flex flex-col-reverse sm:flex-row sm:flex-wrap sm:justify-end gap-2 sm:gap-2">

        <button type="button" tuiButton appearance="outline" size="m" (click)="closeExpiringClientsDialog()"
          class="justify-center whitespace-nowrap">

          Dismiss

        </button>

        <button type="button" tuiButton appearance="flat" size="m" (click)="snoozeExpiringClientsForToday()"
          class="justify-center whitespace-nowrap">

          Don't display again today

        </button>

        <button type="button" tuiButton appearance="primary" size="m" (click)="navigateToExpiringClients()"
          class="justify-center whitespace-nowrap">

          View expiring clients

        </button>

      </div>

    </div>

  </div>

</div>